import React from 'react';
import api from 'api';
import Modal from '../Modal';

export default class ScoreBreakdownModal extends React.Component {    
    state = {
        loaded: false,
        scoreBreakdown: []
    }
    async componentDidMount() {
        console.log('p', );
        var resultWithValue = await api.get(`clients/${this.props.client.id}/score_breakdown`);
        var scoreBreakdown = resultWithValue.value;
        console.log('scoreBreakdown', scoreBreakdown);
        this.setState({
            loaded: true,
            scoreBreakdown
        });
    }
    render() {       
        var { loaded, scoreBreakdown } = this.state;

        return (
            <Modal showCancel={true} className="modal-success" title={"Score Breakdown"}>
                <div className="page-todo">
                    <div className="task">
                        <span className="taskSpan">    
                            {! loaded && 
                                <span>Loading...</span>
                            }  
                            {loaded &&
                                <table className="table table-striped table-responsive">
                                    <thead>
                                        <tr>
                                            <th className="left"></th>                                       
                                            <th className="center"></th>
                                            <th className="center">Score</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { scoreBreakdown.map((breakdown,i) => {
                                            return (
                                                <tr key={i}>
                                                    <th>
                                                        {breakdown[0]}
                                                    </th>
                                                    <td className="center">
                                                        {breakdown[1]}
                                                    </td>
                                                    <td className="center">                                                 
                                                        {breakdown[2]}
                                                    </td>                                                
                                                </tr>
                                            )
                                        })}
                                    </tbody>                                
                                </table>   
                            }                       
                        </span>                        
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ScoreBreakDownModal.js